import { isBefore, subMinutes } from 'date-fns';

import { clearCookies } from './CookieUtils';
import { getLoginRedirectUrl, getLogoutRedirectUrl } from './UrlUtil';

const isBase64Url = (str) => /^[A-Za-z0-9_-]+$/.test(str);

const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    let base64 = base64Url;
    if (isBase64Url(base64Url)) {
      base64 =
        base64Url.replace(/-/g, '+').replace(/_/g, '/') +
        '=='.substring(0, (3 * base64Url.length) % 4);
    }
    const decodedJwt = JSON.parse(atob(base64));

    return decodedJwt;
  } catch (error) {
    console.error('Error parsing JWT:', error);
    return null;
  }
};
export const isTokenExpired = (token) => {
  if (!token) return true;
  const decodedJwt = parseJwt(token);
  return decodedJwt.exp * 1000 < Date.now();
};

export const parseAccessToken = (hash) => {
  if (!hash) return '';

  const fragment = hash.startsWith('#') ? hash.substring(1) : hash;

  try {
    const params = new URLSearchParams(fragment);
    return params.get('access_token') || '';
  } catch (e) {
    const match = fragment.match(/(?:^|&)access_token=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }
};

const REDIRECT_STORAGE_KEY = 'redirect-efix-custom';

const getRedirect = () => localStorage.getItem(REDIRECT_STORAGE_KEY);

const setRedirect = () => {
  localStorage.setItem(
    REDIRECT_STORAGE_KEY,
    JSON.stringify({
      timestamp: new Date().toISOString(),
      pathname: window.location.pathname,
      search: window.location.search,
    })
  );
};

const removeRedirect = () => {
  localStorage.removeItem(REDIRECT_STORAGE_KEY);
};

export const REDIRECT_NOTE_SEARCH_KEY = 'redirectFrom';

const setRedirectSearchNote = (params, redirectedFrom) => {
  params.set(REDIRECT_NOTE_SEARCH_KEY, redirectedFrom);
};

export const tryRedirect = () => {
  const storageRedirect = getRedirect();

  if (!storageRedirect) return;

  removeRedirect();
  try {
    const parsedStorageRedirect = JSON.parse(storageRedirect);

    const timestamp = new Date(parsedStorageRedirect.timestamp);

    // allow max two minutes
    const invalidRedirect = isBefore(timestamp, subMinutes(new Date(), 2));

    if (invalidRedirect) return;

    const pathToRedirect = parsedStorageRedirect.pathname;
    const searchToRedirect = parsedStorageRedirect.search || '';

    if (!pathToRedirect.startsWith('/')) return;

    if (
      window.location.pathname === pathToRedirect &&
      window.location.search === searchToRedirect
    ) {
      return;
    }

    const replaceUrl = new URL(window.location);

    replaceUrl.pathname = pathToRedirect;
    replaceUrl.search = searchToRedirect;

    if (window.location.pathname !== pathToRedirect) {
      setRedirectSearchNote(replaceUrl.searchParams, replaceUrl.pathname);
    }

    window.location.replace(replaceUrl);
  } catch (e) {
    console.error('Redirect failed', e);
  }
};

export const logoutWithRedirect = (isCIAM) => {
  // Built before wiping storage below - it needs the tenant id that lives there.
  const redirectUrl = getLogoutRedirectUrl(isCIAM);

  localStorage.clear();
  clearCookies();
  setRedirect();
  window.location.href = redirectUrl;
};

/**
 * Sends an unauthenticated visitor to the identity provider's sign-in page.
 */
export const loginWithRedirect = (isCIAM) => {
  const redirectUrl = getLoginRedirectUrl(isCIAM);

  localStorage.clear();
  clearCookies();
  setRedirect();
  window.location.href = redirectUrl;
};
